/**
 * Grade sort helpers shared across the UI.
 *
 * Grades may be legacy short forms ("K", "5") or verbatim curriculum-repo
 * course names ("Kindergarten", "1st Grade", "5th Grade: US History
 * (1491-1850)", "High School: US Government", "Digital PSAT 8/9").
 *
 * Sort buckets:
 *   0 — Kindergarten / "K"          (always first)
 *   1 — leading-digit grades        (numeric, by digit; ties broken by full string)
 *   2 — anything else               (HS courses, etc.) alphabetically
 */

export const gradeSortKey = (g) => {
  const s = String(g);
  if (s === "K" || s === "k" || s === "Kindergarten") {
    return [0, 0, ""];
  }
  const numMatch = s.match(/^(\d+)/);
  if (numMatch) {
    return [1, parseInt(numMatch[1], 10), s];
  }
  return [2, 0, s];
};

export const compareGrades = (a, b) => {
  const ka = gradeSortKey(a);
  const kb = gradeSortKey(b);
  for (let i = 0; i < 3; i++) {
    if (ka[i] < kb[i]) {
      return -1;
    }
    if (ka[i] > kb[i]) {
      return 1;
    }
  }
  return 0;
};
